import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "./EmailPreview.module.css";
import {
  switchEditorModules,
  insertModule,
  selectEditorModule,
} from "../../actions";
import EmailModule from "../../components/EmailModule";
import { mapValues } from "lodash";

function fieldsDataToModuleData(fields) {
  return mapValues(fields, (value, key) => {
    if (value.type === "group") {
      return fieldsDataToModuleData(value);
    }
    return value.value || value.defaultValue;
  });
}

export class EmailPreview extends Component {
  constructor(props) {
    super(props);
    this.renderModule = this.renderModule.bind(this);
    this.dragStart = this.dragStart.bind(this);
    this.dragEnd = this.dragEnd.bind(this);
    this.dragOver = this.dragOver.bind(this);
    this.dragEnter = this.dragEnter.bind(this);
    this.dragLeave = this.dragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.state = {
      dragOver: false,
      dropIndex: -1,
    };
    this.dragCounter = 0;
  }

  componentDidMount() {
    window.addEventListener("dragend", this.dragEnd);
  }

  componentWillUnmount() {
    window.removeEventListener("dragend", this.dragEnd);
  }

  dragStart(hoverIndex) {
    return (e) => {
      this.dragged = e.currentTarget;
      e.dataTransfer.effectAllowed = "move";

      this.fromIndex = hoverIndex;

      // Firefox requires calling dataTransfer.setData
      // for the drag to properly work
      e.dataTransfer.setData("text/html", e.currentTarget);
    };
  }

  dragEnd(e) {
    if (this.dragged) {
      this.dragged.style.display = "block";
      this.dragged = false;
    }
    this.dragCounter = 0;

    this.setState({
      dragOver: false,
      dropIndex: -1,
    });
  }

  dragOver(hoverIndex) {
    return (e) => {
      e.preventDefault();

      if (this.dragged) {
        this.dragged.style.display = "none";
      }

      this.over = e.currentTarget;

      var scrollTop =
        this.over.parentNode.parentNode.parentNode.parentNode.parentNode
          .scrollTop;

      window.over = this.over;

      // Inside the dragOver method
      var relY = e.clientY - this.over.offsetTop - 180 + scrollTop;
      var height = 150;

      if (relY > height) {
        this.nodePlacement = "after";
        this.setState({
          dragOver: true,
          dropIndex: hoverIndex + 1,
        });
      } else if (relY < height) {
        this.nodePlacement = "before";
        this.setState({
          dragOver: true,
          dropIndex: hoverIndex,
        });
      }
    };
  }

  dragEnter(e) {
    this.dragCounter++;
    this.setState({
      dragOver: true,
    });
  }

  dragLeave(e) {
    this.dragCounter--;
    if (this.dragCounter <= 0) {
      this.setState({
        dragOver: false,
        dropIndex: -1,
      });
    }
  }

  onDrop(e) {
    e.preventDefault();

    const { accountId } = this.props;
    const { dropIndex } = this.state;

    var moduleId = e.dataTransfer.getData("text/plain");

    if (moduleId) {
      if (moduleId.startsWith("module:")) {
        this.props.insertModule(
          accountId,
          moduleId.replace(/^module:/, ""),
          dropIndex
        );
      } else {
        console.log("Invalid module", moduleId);
      }
    } else {
      if (this.fromIndex >= dropIndex) {
        this.props.switchEditorModules(this.fromIndex, dropIndex);
      } else {
        this.props.switchEditorModules(this.fromIndex, dropIndex - 1);
      }
    }

    this.setState({ dropIndex: -1, dragOver: false });
    this.dragCounter = 0;
  }

  renderModule(module, index, modules) {
    const { email, breakdown, country, subject, displayWidth } = this.props;
    const { dropIndex, dragOver } = this.state;
    const selected = index === this.props.selectedModule;

    const onSelect = () => {
      this.props.selectEditorModule(index);
    };

    const onMoveUp = () => {
      this.props.switchEditorModules(index, index - 1);
    };

    const onMoveDown = () => {
      this.props.switchEditorModules(index, index + 1);
    };

    const fields = module.fields || {};

    const globalData = fieldsDataToModuleData(email.fields.data || {});

    const moduleData = Object.assign(
      {},
      fieldsDataToModuleData(fields.data || {}),
      {
        country,
        subject,
        global: globalData,
      }
    );

    return (
      <div
        key={index + "_" + module.id}
        data-id={index}
        className={styles.module}
        draggable="true"
        onDragEnd={this.dragEnd}
        onDragStart={this.dragStart(index)}
        onDragOver={this.dragOver(index)}
        onDrop={this.onDrop}
      >
        {index === dropIndex && <div className={styles.placeholder} />}
        <EmailModule
          id={module.id}
          accountId={this.props.accountId}
          emailId={email.id}
          variation={email.var}
          translations={email.translations}
          width={displayWidth}
          name={module.name}
          data={moduleData}
          breakdown={breakdown}
          selected={selected}
          index={index}
          onSelect={onSelect}
          onMoveUp={onMoveUp}
          onMoveDown={onMoveDown}
          showMoveUp={index > 0}
          showMoveDown={index < modules.length - 1}
          dragOver={dragOver}
          editor
        />
        {index + 1 === dropIndex && index === modules.length - 1 && (
          <div className={styles.placeholder} />
        )}
      </div>
    );
  }

  render() {
    const { id, email, emailTemplate, displayWidth, modules, subject } =
      this.props;
    const { dropIndex } = this.state;

    if (!email) {
      return <div />;
    }

    if (!emailTemplate) {
      return <div />;
    }

    const onSelectDocument = () => {
      this.props.selectEditorModule(false);
    };

    const noModules =
      modules.length === 0 ? (
        <div
          className={styles.info}
          onDragOver={this.dragOver(0)}
          onDrop={this.onDrop}
        >
          <div>
            Drag modules from left sidebar into this space to begin building.
          </div>
        </div>
      ) : (
        <div />
      );

    return (
      <div
        key={id}
        className={
          displayWidth < 480 ? styles.mobileContainer : styles.container
        }
        style={{ width: displayWidth }}
        onDragEnter={this.dragEnter}
        onDragLeave={this.dragLeave}
      >
        <div className={styles.header} onClick={onSelectDocument}>
          <div className={styles.receiveDate}>1 May 2016 20:06</div>
          <div className={styles.sender}>Mercury (no reply)</div>
          <div className={styles.inbox}>Inbox</div>
          <div className={styles.subject}>{subject || "Subject line"}</div>
        </div>
        <div className={styles.dropzone}>
          {modules.length > 0 ? (
            <div>{modules.map(this.renderModule)}</div>
          ) : dropIndex === -1 ? (
            noModules
          ) : (
            <div
              className={styles.placeholder}
              onDragOver={this.dragOver(0)}
              onDrop={this.onDrop}
            />
          )}
        </div>
      </div>
    );
  }
}

EmailPreview.propTypes = {
  modules: PropTypes.array,
  insertModule: PropTypes.func,
  selectEditorModule: PropTypes.func,
};

// Connect state data
function mapStateToProps(state) {
  const { email, displayWidth, breakdown, selectedModule } = state.editor;
  const modules = email ? email.modules : [];
  const subject = email ? email.subject : "Test subject";
  const country = email && email.country;
  const id = email && email.id;
  const emailTemplate = email && email.EmailTemplate;

  return {
    id,
    email,
    displayWidth: Math.max(250, displayWidth),
    breakdown,
    subject,
    country,
    modules,
    selectedModule,
    emailTemplate,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  insertModule,
  switchEditorModules,
  selectEditorModule,
})(EmailPreview);
